import { render, staticRenderFns } from "./OtherMenuHeader.vue?vue&type=template&id=0fa1eb09&"
import script from "./OtherMenuHeader.vue?vue&type=script&lang=js&"
export * from "./OtherMenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports